
import { useRef, useEffect } from 'react';
import { useLoadGoogleMapsScript } from './useLoadGoogleMapsScript';
import { useAutocompleteInitialization } from './useAutocompleteInitialization';
import { useDropdownStyles } from './useDropdownStyles';
import { usePlaceDetails } from './usePlaceDetails';
import { PlaceResult, UseGooglePlacesAutocompleteProps, UseGooglePlacesAutocompleteReturn } from './types';

export type { PlaceResult };

export const useGooglePlacesAutocomplete = ({ 
  apiKey 
}: UseGooglePlacesAutocompleteProps): UseGooglePlacesAutocompleteReturn => {
  const inputRef = useRef<HTMLInputElement>(null);
  
  const { 
    isLoaded, 
    isLoadingScript, 
    error, 
    loadScript 
  } = useLoadGoogleMapsScript();
  
  const { 
    place, 
    handlePlaceChanged, 
    getPlaceDetails 
  } = usePlaceDetails();
  
  useAutocompleteInitialization({
    isLoaded,
    inputRef,
    onPlaceChanged: handlePlaceChanged
  });
  
  useDropdownStyles(isLoaded);
  
  // Load script on mount
  useEffect(() => {
    if (apiKey) {
      loadScript(apiKey);
    }
  }, [apiKey]);
  
  // Reload script with new API key
  const reloadWithNewApiKey = (newApiKey: string) => {
    loadScript(newApiKey);
  };
  
  return {
    isLoaded,
    isLoadingScript,
    error,
    inputRef,
    place,
    getPlaceDetails,
    reloadWithNewApiKey
  };
};
